var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"chatapp-wrap"},[_c('chatElementLeft',{attrs:{"link_to_communication_in":_vm.link_to_communication_in,"verantwortliche":_vm.verantwortliche}}),_vm._v(" "),_c('chatElementRight',{attrs:{"chat":_vm.chat,"meldung":_vm.meldung}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }